import { ReactNode } from 'react';
import { Icon, IconName } from '@frontend/icons';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { CommonHTMLAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { Text, styles } from '@frontend/design-system';

export type ContextPreviewProps = {
  iconName: IconName;
  title: ReactNode;
  subtitle: ReactNode;
};

export const ContextPreview = ({
  iconName,
  title,
  subtitle,
  ...rest
}: ContextPreviewProps & Omit<CommonHTMLAttributes, 'title'>) => {
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.min });

  const titleComponent =
    typeof title === 'string' || typeof title === 'number' ? <Text weight='bold'>{title}</Text> : title;
  const subtitleComponent =
    typeof subtitle === 'string' || typeof subtitle === 'number' ? (
      <Text color='light' size='medium' css={styles.truncate}>
        {subtitle}
      </Text>
    ) : (
      subtitle
    );

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        borderRadius: theme.borderRadius.medium,
        backgroundColor: theme.colors.neutral5,
        padding: theme.spacing(1),
        flexGrow: 1,
        overflow: 'hidden',
      }}
      {...rest}
    >
      <Icon
        name={iconName}
        size={isMobile ? 24 : 32}
        css={{
          minWidth: isMobile ? 24 : 32,
        }}
      />
      <div css={styles.truncate}>
        {titleComponent}
        {subtitleComponent}
      </div>
    </div>
  );
};
